import { Component, OnInit, Input } from '@angular/core';
import { SetService, PageService, JwtService, HttpService } from 'ngx-block-core';
import { FormGroup } from '@angular/forms';
import { FormControlService } from "ngx-block-core";
import { selectSize, iconTheme } from "../../../data/data";

@Component({
    selector: 'app-sucu04-weiget0070001',
    templateUrl: './sucu04-weiget0070001.component.html',
})

export class Sucu04Weiget0070001Component implements OnInit {
    @Input() local = false;
    @Input() static = false;
    @Input() blockid = "-1";
    @Input() layoutid = "-1";
    @Input() form: FormGroup;
    @Input() nzFormGroupData;
    @Input() nzLayout = 'horizontal'
    @Input() acl = 'cy';
    value
    @Input() sets = {
        blockCode: "sucublock46",
        blockId: "",
        blockName: "文本域",
        layoutId: "",
        blockType: 'formBlock',
        blockChildType: '',
        versionCode: 8,
        attributes: ['form', 'nzFormGroupData', 'nzLayout'],
        sets: {
            acl: false
        },
        events: [
            {
                label: "自动补全",
                value: "auto",
                data: { setParams: ["开启值", '关闭值', 'en_reset（启用时重置值）,dis_reset（禁用时重置值）'] }
            },
            {
                label: "校验开关",
                value: "valid",
                data: { setParams: ["开启值,@other", '关闭值,@other', '校验类型:required,min,max，minlength，maxlength，pattern，phone，email，equal，conditions'] }
            },
        ],
        styles: {
            nzTextColor: "",
            nzSize: "default",
            nzPlaceHolder: "请输入内容",
            nzLayout: {
                nzLayout1: 0,
                nzLayout2: 8,
                nzLayout3: 0,
                nzLayout4: 16,
                nzAlign: 'left',
                nzMarginBottom: 3,
                nzLineHeight: 1.4,
                nzFontSize: 12
            },
            nzRequired: false,
            nzHasFeedback: true,
            nzReadOnly: false,
            nzRow: 2,
            nzAutosize: false,
            nzAutosizeSet: {
                minRows: 2,
                maxRows: 6
            },
            nzIcon: {
                nzIconType: '',
                nzIconTheme: ''
            },
            nzNoSee: false
        },
        datas: {
            nzSearchDataType: "string|array",
            nzSearchType: "like",
            nzAutocomplete: {
                nzUsed: false,
                nzGetData: true,
                nzDynamicSql: "",
                nzData: [],
                nzClickEvents: {
                    nzEvents: [

                    ],
                    nzEventsDatas: {
                    },
                }

            }
        }
    };

    setData = []
    nzAutocompleteData = [];
    nzAutocompleteUsed = false;
    constructor(
        public setService: SetService,
        public formControlService: FormControlService,
        protected pageService: PageService,
        protected jwtService: JwtService,
        protected http: HttpService,

    ) { }

    ngOnInit() {
        this.baseInit();


        this.getAutocomplete();
    }
    getAutocomplete() {
        this.nzAutocompleteData = this.sets.datas.nzAutocomplete.nzData;//后期做静态配置
        this.nzAutocompleteUsed = this.sets.datas.nzAutocomplete.nzUsed;
        if (this.sets.datas.nzAutocomplete.nzDynamicSql !== '' && this.sets.datas.nzAutocomplete.nzGetData) {
            //查询自动组装数据
            console.log('nzAutocomplete', '需要查询');
            setTimeout(async () => {
                console.log('nzAutocomplete', '开始查询数据');

                const datas = {
                    nzDynamicSql: this.sets.datas.nzAutocomplete.nzDynamicSql,
                    layoutid: this.layoutid,
                    blockid: this.blockid,
                    blockName: this.sets.blockName
                }
                let salData = await this.pageService.getSqlData(datas);
                if (salData !== '') {
                    this.nzAutocompleteData = salData;
                }
                console.log('nzAutocomplete', '查询结果', salData);
            }, 100);
        }
    }
    nzAutoClick(data) {
        //点击发送事件
        console.log('nzAutoClick', data);
        //事件
        //事件
        const val = data.EVENT;
        if (!val) return;
        console.log('nzAutoClick', '存在事件', val);

        this.sets.datas.nzAutocomplete.nzClickEvents.nzEvents.forEach(element => {
            this.sets.datas.nzAutocomplete.nzClickEvents.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
                switch (element) {
                    case 'sendSimpleEvent':
                        // this.endEvent.push(element);

                        switch (itemEvents['name']) {
                            case "search":
                                if (val !== null && val !== undefined) {
                                    let data = {};
                                    if (itemEvents['param1'] === '' || itemEvents['param1'] === null || itemEvents['param1'] === undefined) itemEvents['param1'] = '=';
                                    data[itemEvents['param0']] = [
                                        {
                                            "name": itemEvents['param1'],
                                            "type": "",
                                            "instruction": "",
                                            "value1": val,
                                            "value2": ""
                                        }
                                    ]
                                    this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], data)
                                    console.log("jsonsss", JSON.stringify(this.sets.datas.nzAutocomplete.nzClickEvents.nzEventsDatas[element]), data)
                                }
                                break;
                            case "updateNum":
                                this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], {
                                    value:val,
                                    upField:itemEvents['param0']
                                  })
                                console.log("updateNum", JSON.stringify(this.sets.datas.nzAutocomplete.nzClickEvents.nzEventsDatas[element]), {
                                    value:val,
                                    upField:itemEvents['param0']
                                  })
                                break;

                            default:


                                let senddata = { value: val };
                                try {
                                    senddata['param0'] = itemEvents['param0'];
                                    senddata['param1'] = itemEvents['param1'];
                                    senddata['param2'] = itemEvents['param2'];
                                } catch (error) {

                                }
                                console.log("send", this.blockid, itemEvents['blockid'], itemEvents['name'], senddata)
                                this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], senddata)
                                break;
                        }

                        break;

                    default:
                        break;
                }
            });

        });
    }
    autoUpdate() {

        //v3,升级自定义表单参数
        if (this.sets.versionCode < 2) {

            this.sets.blockCode = "sucublock46";

            this.sets.versionCode = 2;
        }
        if (this.sets.versionCode < 3) {

            this.sets.styles.nzNoSee = false;

            this.sets.versionCode = 3;
        }
        if (this.sets.versionCode < 4) {

            this.sets.datas.nzAutocomplete = {
                nzUsed: false,
                nzGetData: true,
                nzDynamicSql: "",
                nzData: [],
                nzClickEvents: {
                    nzEvents: [

                    ],
                    nzEventsDatas: {
                    },
                }
            }

            this.sets.versionCode = 4;
        }
        if (this.sets.versionCode < 6) {

            this.sets.datas.nzAutocomplete['nzData'] = []
            this.sets.datas.nzAutocomplete['nzClickEvents'] = {
                nzEvents: [

                ],
                nzEventsDatas: {
                },
            }
            this.sets.events = [
                {
                    label: "自动补全",
                    value: "auto",
                    data: { setParams: ["开启值", '关闭值', 'en_reset（启用时重置值）,dis_reset（禁用时重置值）'] }
                },
            ]
            this.sets.versionCode = 6;
        }
        if (this.sets.versionCode < 7) {

            this.sets.datas.nzAutocomplete['nzClickEvents'] = {
                nzEvents: [

                ],
                nzEventsDatas: {
                },
            }

            this.sets.versionCode = 7;
        }
        if (this.sets.versionCode < 8) {

            this.sets.events = [
                {
                    label: "自动补全",
                    value: "auto",
                    data: { setParams: ["开启值", '关闭值', 'en_reset（启用时重置值）,dis_reset（禁用时重置值）'] }
                },
                {
                    label: "校验开关",
                    value: "valid",
                    data: { setParams: ["开启值,@other", '关闭值,@other', '校验类型:required,min,max，minlength，maxlength，pattern，phone，email，equal，conditions'] }
                },
            ]
            this.sets.versionCode = 8;
        }




    }
    setDataInit() {
        this.setData = [
            {
                tabName: '数据',
                datas: [
                    {
                        type: 'datas',
                        data: [
                            { name: 'nzFormDataSource' },
                            { name: 'nzFormSearchType' },
                            {
                                name: 'switch',
                                inputs: {
                                    nzText: "补全启用 : ", nzKeys: ['datas', 'nzAutocomplete', 'nzUsed'], nzPopContent: "启用自动补全，自动补全目前只是类似下拉框功能，后期再调整"
                                }
                            },
                            {
                                name: 'switch',
                                inputs: {
                                    nzText: "补全数据 : ", nzKeys: ['datas', 'nzAutocomplete', 'nzGetData'], nzPopContent: "开启后，如果存在补全SQL，则会默认查询数据，无论补全是否启用"
                                }
                            },
                            {
                                name: 'input',
                                inputs: {
                                    nzText: "补全SQL : ", nzKeys: ['datas', 'nzAutocomplete', 'nzDynamicSql'], nzType: "textarea",
                                    nzAutosize: { minRows: 3, maxRows: 6 },
                                    nzPopContent: "暂时只支持静态SQL，不支持联动，格式 AS VALUE,AS LABEL,AS EVENT"
                                }
                            },
                            {
                                name: "nzEvents", inputs: {
                                    eventType: [
                                        { value: 'sendSimpleEvent', label: '发送简单通知' },
                                    ],
                                    title: '补全点击事件',
                                    nzEventsFather: this.sets.datas.nzAutocomplete.nzClickEvents
                                }
                            },
                        ]
                    }
                ]
            },
            {
                tabName: '样式',
                datas: [
                    {
                        type: 'styles',
                        data: [
                            {
                                name: 'input',
                                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
                            },
                            {
                                name: 'number',
                                inputs: { nzText: "行数 : ", nzKeys: ['styles', 'nzRow'], nzPopContent: "开启自适应失效" }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "自适应高度 : ", nzKeys: ['styles', 'nzAutosize'] }
                            },
                            {
                                name: 'number',
                                inputs: { nzText: "最小高度 : ", nzKeys: ['styles', 'nzAutosizeSet', 'minRows'], nzPopContent: "开启自适应生效" }
                            },
                            {
                                name: 'number',
                                inputs: { nzText: "最大高度 : ", nzKeys: ['styles', 'nzAutosizeSet', 'maxRows'], nzPopContent: "开启自适应生效" }
                            },
                            {
                                name: 'color',
                                inputs: { nzText: "文字颜色 : ", nzKeys: ['styles', 'nzTextColor'] }
                            },
                            {
                                name: 'input',
                                inputs: { nzText: "提示文字 : ", nzKeys: ['styles', 'nzPlaceHolder'] }
                            },
                            {
                                name: 'input',
                                inputs: { nzText: "前置标签 : ", nzModel: this.nzFormGroupData['nzValue'], nzKeys: ['nzValueBefore'] },
                                outputs: { ngModelChange: (event) => { if (event == '') this.setService.onReLoadbBlock(this.layoutid) } }

                            },
                            {
                                name: 'input',
                                inputs: { nzText: "后置标签 : ", nzModel: this.nzFormGroupData['nzValue'], nzKeys: ['nzValueAfter'] }
                            },
                            {
                                name: 'input',
                                inputs: { nzText: "前置图标 : ", nzKeys: ['styles', 'nzIcon', 'nzIconType'], nzPopContent: ['填入type,请参照官方文档:', 'https://ng.ant.design/components/icon/zh'] }
                            },
                            {
                                name: 'radio',
                                inputs: { nzText: "前置图标主题:", nzKeys: ['styles', 'nzIcon', 'nzIconTheme'], nzData: iconTheme, },
                                outputs: { ngModelChange: () => { if (this.sets.styles.nzIcon.nzIconTheme == '') this.setService.onReLoadbBlock(this.layoutid) } }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "只读 : ", nzKeys: ['styles', 'nzReadOnly'] }
                            },
                            {
                                name: 'nzLayout'
                            },
                            {
                                name: 'radio',
                                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "显示必填* : ", nzKeys: ['styles', 'nzRequired'], nzPopContent: ['仅影响样式'] }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "校验图标 : ", nzKeys: ['styles', 'nzHasFeedback'], nzPopContent: ['校验状态的图标'] }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "密码样式 : ", nzKeys: ['styles', 'nzPassword'] }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "表单忽视 : ", nzKeys: ['styles', 'nzNoSee'] },
                                outputs: {
                                    ngModelChange: (event) => {
                                        if (event)
                                            this.nzFormGroupData['nzSearchDataType'] = "noSee";
                                        else
                                            this.nzFormGroupData['nzSearchDataType'] = "string|array";
                                    }
                                }
                            },
                        ]
                    },
                ]
            },
            {
                tabName: '表单',
                datas: [
                    {
                        type: 'datas',
                        data: [
                            { name: 'nzFormSet' },
                        ]
                    }
                ]
            },

        ]
    }
    baseInit() {

        if (!this.local) {//非本地
            if (!this.static) {//非静态
                if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
                    this.sets = this.setService.blocksort[this.blockid]['sets'];
                } else {
                    this.setService.blocksort[this.blockid]['sets'] = this.sets;
                }
                this.sets.blockId = this.blockid;
                this.sets.layoutId = this.layoutid;
                this.nzFormGroupData['nzSearchDataType'] = "string|array";
                if (this.nzFormGroupData['nzSearchType'] == 'null')
                    this.nzFormGroupData['nzSearchType'] = "like";
                this.autoUpdate();
                this.setDataInit();
                if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
                    this.setService.setDatas[this.blockid] = this.setData;
                }

                this.pzListening()
            }
            else {//静态
                if (typeof this.sets == "string")
                    this.sets = JSON.parse(<any>this.sets);
                this.blockid = this.sets.blockId;
                this.layoutid = this.sets.layoutId;
                this.autoUpdate();
            }
        }
        this.Listening()
    }
    ngOnDestroy() {
        if (!this.static) this.setService.deleteEvent(this.blockid, 'pz')
    }


    pzListening() {
        setTimeout(() => {
            this.setService.initEvent(this.blockid, 'pz');
            this.setService.pzEvents[this.blockid].subscribe(data => {
                switch (data['type']) {
                    case 'changeFormValid':
                        this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
                        break;

                    default:
                        break;
                }
            }
            )
        }, 100);

    }

    Listening() {
        console.log("Listening", this.blockid)
        setTimeout(() => {
            this.setService.initEvent(this.blockid);
            this.setService.events[this.blockid].subscribe(
                data => {
                    let array0 = [];
                    let array1 = [];
                    switch (data['type']) {
                        case 'auto':

                            console.log("data.datas.value", data.datas.value, data.datas.param0, data.datas.value == data.datas.param0)
                            array0 = (data.datas.param0 + "").split(",");
                            array1 = (data.datas.param1 + "").split(",");
                            if (array0.indexOf(data.datas.value) >= 0) {

                                this.nzAutocompleteUsed = true;
                                if ((data.datas.param2 + '').indexOf('en_reset') >= 0) {
                                    this.form.get(this.nzFormGroupData.nzKey).patchValue('')
                                    this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
                                    this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
                                }

                            } else if (array1.indexOf(data.datas.value) >= 0) {
                                this.nzAutocompleteUsed = false;
                                if ((data.datas.param2 + '').indexOf('dis_reset') >= 0) {
                                    this.form.get(this.nzFormGroupData.nzKey).patchValue('')
                                    this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
                                    this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
                                }
                            }
                            break;
                        case 'valid':
                            console.log("valid", data.datas)
                            array0 = (data.datas.param0 + "").split(",");
                            array1 = (data.datas.param1 + "").split(",");
                            let open = array0.indexOf(data.datas.value) >= 0;
                            let close = array1.indexOf(data.datas.value) >= 0;
                            if (open || (!open && data.datas.param0 === '@other' && !close)) {

                                for (let index = 0; index < this.nzFormGroupData.nzValidators.length; index++) {
                                    const element = this.nzFormGroupData.nzValidators[index];
                                    if (element.nzValidType === data.datas.param2 && element.nzUsed === false) {
                                        element.nzUsed = true;
                                        this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
                                        break;
                                    }

                                }

                            } else if (close || (!close && data.datas.param1 === '@other' && !open)) {
                                for (let index = 0; index < this.nzFormGroupData.nzValidators.length; index++) {
                                    const element = this.nzFormGroupData.nzValidators[index];
                                    if (element.nzValidType === data.datas.param2 && element.nzUsed === true) {
                                        element.nzUsed = false;
                                        this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
                                        break;
                                    }

                                }
                            }
                            break;
                    }


                }
            )
        }, !this.static ? 100 : 0);


    }
    ngModelChange(value) {
        this.formControlService.dataEvent(value, this.nzFormGroupData, this.blockid)
    }



}


